export default __webpack_public_path__ + "static/media/placeholder.6683f960.svg";